export default __webpack_public_path__ + "static/spezia-monospace-semi-mono-medium-739eceda4204509075403a118f3622e7.woff2";